import React, { useState, useEffect, useCallback } from 'react';
import {
  FaHandshake, FaBuilding, FaSearch, FaDownload,
  FaEye, FaTimes, FaCheck, FaLinkedin,
  FaGlobe, FaFilePdf, FaEnvelope,
  FaBriefcase, FaChevronLeft, FaChevronRight,
  FaFileAlt, FaPaperPlane, FaStickyNote,
  FaHistory, FaCheckDouble, FaExclamationTriangle, FaTrash,
  FaCircle, FaUserTie, FaArrowRight, FaRegClock,
  FaThumbsUp, FaThumbsDown, FaEdit, FaPlus, FaIdCard, FaSpinner
} from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';

import { API_URL, BASE_URL } from '../config/api';
const API = `${API_URL}/admin/partners`;
const getToken = () => localStorage.getItem('admin_token');
const authHdr  = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

const SB_OPEN   = 252;
const SB_CLOSED =  74;
const SB_GAP    =  12;
const NB_HEIGHT =  68;
const NB_TOP    =  12;

const DOMAIN_LABEL = {
  finance:'Finance & Comptabilité', rh:'Ressources Humaines',
  marketing:'Marketing & Communication', it:'Informatique & Digital',
  management:'Management & Leadership', juridique:'Juridique & Conformité',
  sante:'Santé & Sécurité', autre:'Autre',
};

const fmtDate = d => d ? new Date(d).toLocaleDateString('fr-FR',{day:'2-digit',month:'short',year:'numeric'}) : '—';
const initials = n => (n||'??').split(' ').map(p=>p[0]||'').join('').slice(0,2).toUpperCase();

// ── Toast ─────────────────────────────────────────────────────────────────────
const Toast = ({ msg, type, onClose }) => (
  <div style={{
    position:'fixed', bottom:24, right:24, zIndex:9999,
    background: type==='error' ? '#dc3545' : '#198754',
    color:'#fff', padding:'13px 20px', borderRadius:12,
    fontSize:14, fontWeight:600, boxShadow:'0 8px 24px rgba(0,0,0,0.18)',
    display:'flex', alignItems:'center', gap:10, maxWidth:380,
  }}>
    {type==='error' ? '❌' : '✅'} {msg}
    <button onClick={onClose} style={{ background:'none', border:'none', color:'#fff', cursor:'pointer', marginLeft:'auto', fontSize:16 }}>×</button>
  </div>
);

const PatnersAdmin = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [data,        setData]        = useState([]);
  const [stats,       setStats]       = useState({ total:0, nouveau:0, en_analyse:0, approuve:0, rejete:0 });
  const [meta,        setMeta]        = useState({ current_page:1, last_page:1, total:0 });
  const [loading,     setLoading]     = useState(true);
  const [search,      setSearch]      = useState('');
  const [fStatus,     setFStatus]     = useState('all');
  const [fType,       setFType]       = useState('all');
  const [sel,         setSel]         = useState(null);
  const [tab,         setTab]         = useState('dossier');
  const [modal,       setModal]       = useState(false);
  const [modalLoading,setModalLoading]= useState(false);
  const [page,        setPage]        = useState(1);
  const [replyTxt,    setReplyTxt]    = useState('');
  const [noteTxt,     setNoteTxt]     = useState('');
  const [sending,     setSending]     = useState(false);
  const [actionLoad,  setActionLoad]  = useState(null);
  const [toast,       setToast]       = useState(null);

  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const PER = 6;

  const C = {
    orange:'#fd7e14', oLight:isDark?'rgba(253,126,20,.12)':'rgba(253,126,20,.08)', oBorder:isDark?'rgba(253,126,20,.28)':'rgba(253,126,20,.18)',
    green:'#198754',  gLight:isDark?'rgba(25,135,84,.12)':'rgba(25,135,84,.08)',   gBorder:isDark?'rgba(25,135,84,.28)':'rgba(25,135,84,.18)',
    red:'#dc3545',    rLight:isDark?'rgba(220,53,69,.12)':'rgba(220,53,69,.08)',   rBorder:isDark?'rgba(220,53,69,.28)':'rgba(220,53,69,.18)',
    amber:'#d97706',  aLight:isDark?'rgba(217,119,6,.12)':'rgba(217,119,6,.08)',   aBorder:isDark?'rgba(217,119,6,.28)':'rgba(217,119,6,.18)',
    slate:'#6b7f92',  sLight:isDark?'rgba(107,127,146,.12)':'rgba(107,127,146,.07)', sBorder:isDark?'rgba(107,127,146,.28)':'rgba(107,127,146,.15)',
    ink:isDark?'#eef2f7':'#1e2d3d', ink2:isDark?'#c8d4e0':'#3d5166',
    muted:isDark?'#5a6b82':'#6b7f92', line:isDark?'rgba(255,255,255,.08)':'#e9edf1',
    bg:isDark?'#090c16':'#f5f7f9', white:isDark?'rgba(255,255,255,.04)':'#ffffff',
    surface:isDark?'rgba(255,255,255,.03)':'#fafbfc', cardBd:isDark?'rgba(255,255,255,.08)':'#e9edf1',
    input:isDark?'rgba(255,255,255,.06)':'#ffffff', inputBd:isDark?'rgba(255,255,255,.12)':'#e9edf1', inputT:isDark?'#eef2f7':'#1e2d3d',
    mhdrBg:isDark?'rgba(255,255,255,.03)':'#fafbfc', trowHov:isDark?'rgba(253,126,20,.04)':'#fdf9f6', thBg:isDark?'rgba(255,255,255,.05)':'#fafbfc',
  };

  const STATUS = {
    nouveau:    { label:'Nouveau',      color:C.slate,  bg:C.sLight,  border:C.sBorder },
    en_analyse: { label:'En analyse',   color:C.amber,  bg:C.aLight,  border:C.aBorder },
    approuve:   { label:'Approuvé',     color:C.green,  bg:C.gLight,  border:C.gBorder },
    rejete:     { label:'Rejeté',       color:C.red,    bg:C.rLight,  border:C.rBorder },
    en_attente: { label:'En attente',   color:C.orange, bg:C.oLight,  border:C.oBorder },
    // statuts formulaire public (fallback)
    submitted:  { label:'Soumis',       color:C.slate,  bg:C.sLight,  border:C.sBorder },
    review:     { label:'En révision',  color:C.amber,  bg:C.aLight,  border:C.aBorder },
    accepted:   { label:'Accepté',      color:C.green,  bg:C.gLight,  border:C.gBorder },
    rejected:   { label:'Rejeté',       color:C.red,    bg:C.rLight,  border:C.rBorder },
    draft:      { label:'Brouillon',    color:C.slate,  bg:C.sLight,  border:C.sBorder },
  };
  const HISTO_COLOR = { recu:C.slate, analyse:C.amber, ok:C.green, email:C.green, wait:C.amber, rejet:C.red, note:C.orange, action:C.slate };

  const showToast = (msg, type='success') => { setToast({msg, type}); setTimeout(()=>setToast(null), 4000); };

  // ── Fetch liste ───────────────────────────────────────────────────────────
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(API, {
        params: { search: search||undefined, status: fStatus!=='all'?fStatus:undefined, type: fType!=='all'?fType:undefined, page, per_page: PER },
        ...authHdr(),
      });
      setData(res.data.data);
      setStats(res.data.stats);
      setMeta(res.data.meta);
    } catch (e) {
      showToast(e.response?.data?.message || 'Erreur de chargement.', 'error');
    } finally {
      setLoading(false);
    }
  }, [search, fStatus, fType, page]);

  useEffect(() => {
    const t = setTimeout(fetchData, 300);
    return () => clearTimeout(t);
  }, [fetchData]);

  // ── Ouvrir modal ──────────────────────────────────────────────────────────
  const openModal = async (item, t='dossier') => {
    setTab(t); setModal(true); setReplyTxt(''); setNoteTxt('');
    setSel(item); setModalLoading(true);
    try {
      const res = await axios.get(`${API}/${item.db_id}`, authHdr());
      setSel(res.data);
    } catch (e) {
      showToast('Erreur chargement du dossier.', 'error');
    } finally {
      setModalLoading(false);
    }
  };
  const closeModal = () => { setModal(false); setSel(null); };

  // ── Changer statut ────────────────────────────────────────────────────────
  const changeStatus = async (id, dbId, status) => {
    setActionLoad(dbId+'_status');
    try {
      const res = await axios.patch(`${API}/${dbId}/status`, { status }, authHdr());
      setData(p => p.map(d => d.db_id===dbId ? {...d, status} : d));
      if (sel?.db_id===dbId) setSel(res.data.data);
      showToast('Statut mis à jour.');
    } catch (e) {
      showToast(e.response?.data?.message || 'Erreur.', 'error');
    } finally {
      setActionLoad(null);
    }
  };

  // ── Ajouter note ──────────────────────────────────────────────────────────
  const addNote = async (dbId) => {
    if (!noteTxt.trim()) return;
    setActionLoad(dbId+'_note');
    try {
      const res = await axios.post(`${API}/${dbId}/notes`, { content: noteTxt }, authHdr());
      setSel(p => ({...p, notes:[...p.notes, res.data.note], historique:[...p.historique, {action:'Note interne ajoutée', date: new Date().toLocaleString('fr-FR'), icone:'note'}]}));
      setNoteTxt('');
      showToast('Note enregistrée.');
    } catch (e) {
      showToast(e.response?.data?.message || 'Erreur.', 'error');
    } finally {
      setActionLoad(null);
    }
  };

  // ── Envoyer email ─────────────────────────────────────────────────────────
  const sendReply = async (dbId) => {
    if (!replyTxt.trim()) return;
    setSending(true);
    try {
      await axios.post(`${API}/${dbId}/contact`, { message: replyTxt }, authHdr());
      setSel(p => ({...p, reponses:[...p.reponses, {auteur:'Admin CINEF', date: new Date().toLocaleString('fr-FR'), texte: replyTxt}]}));
      setReplyTxt('');
      showToast('Email envoyé avec succès.');
    } catch (e) {
      showToast(e.response?.data?.message || "Erreur d'envoi.", 'error');
    } finally {
      setSending(false);
    }
  };

  // ── Supprimer ─────────────────────────────────────────────────────────────
  const deleteItem = async (dbId) => {
    if (!window.confirm('Supprimer définitivement ce dossier ?')) return;
    setActionLoad(dbId+'_delete');
    try {
      await axios.delete(`${API}/${dbId}`, authHdr());
      setData(p => p.filter(d => d.db_id !== dbId));
      setStats(p => ({...p, total: p.total-1}));
      closeModal();
      showToast('Dossier supprimé.');
    } catch (e) {
      showToast(e.response?.data?.message || 'Erreur suppression.', 'error');
    } finally {
      setActionLoad(null);
    }
  };

  // ── Export CSV ────────────────────────────────────────────────────────────
  const exportCSV = async () => {
    try {
      const res = await axios.get(`${API}/export`, {
        params: { status: fStatus!=='all'?fStatus:undefined, type: fType!=='all'?fType:undefined },
        responseType: 'blob',
        ...authHdr(),
      });
      const url = URL.createObjectURL(res.data);
      const a   = document.createElement('a');
      a.href    = url;
      a.download = `partenaires_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      showToast("Erreur lors de l'export.", 'error');
    }
  };

  const displayName = d => d.type==='consultant' ? `${d.prenom||''} ${d.nom||''}`.trim() : (d.nomEntreprise||'');
  const location    = d => d.type==='consultant' ? `${d.ville||''}, ${d.pays||''}` : `${d.villeEntreprise||''}, ${d.paysEntreprise||''}`;
  const domain      = d => d.type==='consultant' ? (DOMAIN_LABEL[d.domaineExercice]||d.domaineExercice||'—') : (d.nomRepresentant||'—');
  const statusCfg   = s => STATUS[s] || STATUS.draft;

  const mainML = `${SB_GAP + (sidebarOpen ? SB_OPEN : SB_CLOSED) + 12}px`;
  const mainPT = `${NB_TOP + NB_HEIGHT + 12}px`;

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif", background:C.bg, minHeight:'100vh', color:C.ink }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        *,*::before,*::after{margin:0;padding:0;box-sizing:border-box;font-family:'Plus Jakarta Sans',sans-serif;}
        .pw-main{transition:margin-left .28s cubic-bezier(.4,0,.2,1);min-height:100vh;}
        .pb{padding:32px 36px;}
        .top-bar{display:flex;align-items:center;justify-content:space-between;margin-bottom:28px;}
        .top-left{display:flex;align-items:center;gap:18px;}
        .top-icon{width:54px;height:54px;border-radius:14px;background:${C.orange};color:#fff;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0;}
        .top-title{font-size:26px;font-weight:900;color:${C.ink};letter-spacing:-.3px;}
        .top-sub{font-size:15px;color:${C.muted};margin-top:4px;}
        .btn-export{display:flex;align-items:center;gap:9px;padding:12px 24px;background:${C.ink};color:#fff;border:none;border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;cursor:pointer;transition:opacity .2s;}
        .btn-export:hover{opacity:.85;}
        .kpis{display:grid;grid-template-columns:repeat(5,1fr);gap:16px;margin-bottom:26px;}
        .kpi-card{background:${C.white};border:1px solid ${C.cardBd};border-radius:14px;padding:22px 20px;position:relative;overflow:hidden;transition:transform .22s,box-shadow .22s;display:flex;flex-direction:column;gap:5px;}
        .kpi-card:hover{transform:translateY(-3px);box-shadow:0 8px 28px rgba(0,0,0,.08);}
        .kpi-num{font-size:38px;font-weight:900;line-height:1;letter-spacing:-1.5px;}
        .kpi-lbl{font-size:13px;font-weight:700;color:${C.muted};text-transform:uppercase;letter-spacing:.5px;}
        .kpi-bar{position:absolute;bottom:0;left:0;right:0;height:4px;}
        .filters{display:flex;gap:12px;align-items:center;margin-bottom:20px;flex-wrap:wrap;}
        .search-box{flex:1;min-width:260px;display:flex;align-items:center;gap:12px;background:${C.input};border:1.5px solid ${C.inputBd};border-radius:10px;padding:0 18px;height:48px;transition:border-color .2s;}
        .search-box:focus-within{border-color:${C.orange};}
        .search-box svg{color:${C.muted};font-size:15px;flex-shrink:0;}
        .search-box input{flex:1;border:none;outline:none;font-size:16px;font-family:'Plus Jakarta Sans',sans-serif;background:transparent;color:${C.inputT};}
        .toggle-type{display:flex;background:${C.input};border:1.5px solid ${C.inputBd};border-radius:10px;overflow:hidden;}
        .tgl{padding:0 18px;height:46px;border:none;background:transparent;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;color:${C.muted};cursor:pointer;transition:all .18s;border-right:1px solid ${C.cardBd};}
        .tgl:last-child{border-right:none;}
        .tgl:hover{color:${C.orange};}
        .tgl-on{background:${C.orange}!important;color:#fff!important;}
        .sel-status{height:48px;padding:0 16px;background:${C.input};border:1.5px solid ${C.inputBd};border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;color:${C.ink2};cursor:pointer;outline:none;transition:border-color .2s;}
        .sel-status:focus{border-color:${C.orange};}
        .result-label{font-size:15px;font-weight:700;color:${C.muted};white-space:nowrap;}
        .table-card{background:${C.white};border:1px solid ${C.cardBd};border-radius:14px;overflow:hidden;}
        .table-scroll{overflow-x:auto;}
        .tbl{width:100%;border-collapse:collapse;min-width:980px;}
        .tbl thead{border-bottom:2px solid ${C.cardBd};}
        .tbl th{padding:15px 18px;text-align:left;font-size:12px;font-weight:900;color:${C.muted};text-transform:uppercase;letter-spacing:.8px;white-space:nowrap;background:${C.thBg};}
        .trow{border-bottom:1px solid ${C.line};transition:background .15s;cursor:pointer;}
        .trow:hover{background:${C.trowHov};}
        .trow:last-child{border-bottom:none;}
        .tbl td{padding:15px 18px;vertical-align:middle;}
        .empty-td{text-align:center;padding:60px 20px;font-size:16px;font-weight:700;color:${C.muted};}
        .cand-wrap{display:flex;align-items:center;gap:13px;}
        .cav{width:42px;height:42px;border-radius:11px;flex-shrink:0;font-size:14px;font-weight:900;display:flex;align-items:center;justify-content:center;}
        .cname{font-size:15px;font-weight:700;color:${C.ink};}
        .cemail{font-size:13px;color:${C.muted};margin-top:2px;}
        .type-badge{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;padding:5px 11px;border-radius:8px;}
        .tb-c{background:${C.oLight};color:${C.orange};}
        .tb-e{background:${C.gLight};color:${C.green};}
        .domain-main{font-size:15px;font-weight:700;color:${C.ink2};}
        .domain-sub{font-size:13px;color:${C.muted};margin-top:2px;}
        .loc{font-size:14px;color:${C.ink2};font-weight:600;}
        .status-badge{display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:700;padding:6px 13px;border-radius:20px;border:1.5px solid;white-space:nowrap;}
        .date-txt{font-size:14px;color:${C.ink2};font-weight:600;}
        .row-acts{display:flex;gap:6px;}
        .ra{width:34px;height:34px;border-radius:9px;border:1.5px solid ${C.cardBd};background:${C.white};display:flex;align-items:center;justify-content:center;font-size:14px;cursor:pointer;transition:all .18s;color:${C.muted};}
        .ra:disabled{opacity:.4;cursor:not-allowed;}
        .ra-view:hover:not(:disabled){background:${C.oLight};border-color:${C.orange};color:${C.orange};}
        .ra-dec:hover:not(:disabled){background:${C.gLight};border-color:${C.green};color:${C.green};}
        .ra-msg:hover:not(:disabled){background:${C.oLight};border-color:${C.orange};color:${C.orange};}
        .ra-del:hover:not(:disabled){background:${C.rLight};border-color:${C.red};color:${C.red};}
        .pager{display:flex;align-items:center;gap:8px;padding:16px 20px;border-top:1px solid ${C.cardBd};flex-wrap:wrap;}
        .pbt{min-width:40px;height:40px;border-radius:9px;border:1.5px solid ${C.cardBd};background:${C.white};font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;color:${C.ink2};cursor:pointer;display:flex;align-items:center;justify-content:center;gap:4px;transition:all .18s;padding:0 10px;}
        .pbt:hover:not(:disabled){border-color:${C.orange};color:${C.orange};}
        .pbt-on{background:${C.orange}!important;color:#fff!important;border-color:${C.orange}!important;}
        .pbt:disabled{opacity:.3;cursor:default;}
        .pdot{padding:0 4px;color:${C.muted};font-weight:700;}
        .pinfo{font-size:13px;color:${C.muted};font-weight:600;margin-left:auto;}
        .overlay{position:fixed;inset:0;background:${isDark?'rgba(9,12,22,.8)':'rgba(10,16,26,.55)'};backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;z-index:2000;padding:20px;animation:fo .25s;}
        @keyframes fo{from{opacity:0}to{opacity:1}}
        .mbox{background:${isDark?'#0f172a':'#fff'};border:1px solid ${C.cardBd};border-radius:20px;width:100%;max-width:920px;max-height:92vh;display:flex;flex-direction:column;box-shadow:0 30px 80px rgba(0,0,0,.22);overflow:hidden;animation:su .3s cubic-bezier(.34,1.56,.64,1);}
        @keyframes su{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:none}}
        .mhdr{display:flex;align-items:center;justify-content:space-between;padding:22px 26px;border-bottom:1px solid ${C.cardBd};background:${C.mhdrBg};flex-shrink:0;gap:16px;}
        .mhdr-l{display:flex;align-items:center;gap:16px;flex:1;}
        .mav{width:52px;height:52px;border-radius:13px;flex-shrink:0;font-size:17px;font-weight:900;display:flex;align-items:center;justify-content:center;}
        .mhdr-meta{display:flex;align-items:center;gap:10px;margin-bottom:6px;flex-wrap:wrap;}
        .mref{font-size:12px;color:${C.muted};font-weight:700;background:${C.surface};padding:3px 9px;border-radius:6px;border:1px solid ${C.cardBd};}
        .mname{font-size:22px;font-weight:900;color:${C.ink};}
        .msub{font-size:14px;color:${C.muted};margin-top:2px;}
        .mcx{width:38px;height:38px;border-radius:9px;border:1.5px solid ${C.cardBd};background:transparent;display:flex;align-items:center;justify-content:center;font-size:16px;color:${C.muted};cursor:pointer;transition:all .18s;flex-shrink:0;}
        .mcx:hover{background:${C.red};color:#fff;border-color:${C.red};}
        .mtabs{display:flex;gap:6px;padding:14px 22px;border-bottom:1px solid ${C.cardBd};background:${isDark?'rgba(255,255,255,.02)':'#fff'};flex-shrink:0;flex-wrap:wrap;}
        .mtab{display:flex;align-items:center;gap:8px;padding:10px 18px;border-radius:9px;border:1.5px solid ${C.cardBd};background:transparent;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;color:${C.muted};cursor:pointer;transition:all .18s;}
        .mtab:hover{border-color:${C.orange};color:${C.orange};}
        .mtab-on{background:${C.orange}!important;color:#fff!important;border-color:${C.orange}!important;}
        .mscroll{overflow-y:auto;flex:1;}
        .tpad{padding:28px;}
        .section-block{background:${C.surface};border:1px solid ${C.cardBd};border-radius:14px;overflow:hidden;margin-bottom:18px;}
        .sb-title{display:flex;align-items:center;gap:9px;padding:14px 18px;background:${isDark?'rgba(255,255,255,.03)':'#fff'};border-bottom:1px solid ${C.cardBd};font-size:14px;font-weight:900;color:${C.ink2};text-transform:uppercase;letter-spacing:.6px;border-left:4px solid ${C.orange};}
        .info-grid{display:grid;grid-template-columns:1fr 1fr;}
        .ig-item{padding:14px 18px;display:flex;flex-direction:column;gap:4px;border-right:1px solid ${C.cardBd};border-bottom:1px solid ${C.cardBd};}
        .ig-item:nth-child(2n){border-right:none;}
        .ig-item:nth-last-child(-n+2){border-bottom:none;}
        .ig-item label{font-size:11px;font-weight:900;color:${C.muted};text-transform:uppercase;letter-spacing:.5px;}
        .ig-item span{font-size:16px;font-weight:600;color:${C.ink2};margin-top:2px;}
        .ig-item a{color:${C.orange};font-weight:700;text-decoration:none;}
        .ig-item a:hover{text-decoration:underline;}
        .motiv{margin:16px 18px;font-size:16px;line-height:1.8;color:${C.ink2};font-style:italic;border-left:4px solid ${C.orange};padding:12px 16px;background:rgba(253,126,20,.04);border-radius:0 10px 10px 0;}
        .two-cols{display:grid;grid-template-columns:1fr 1fr;gap:16px;}
        .doc-card{display:flex;align-items:center;gap:14px;padding:16px 18px;}
        .doc-info{flex:1;}
        .doc-name{font-size:15px;font-weight:700;color:${C.ink2};}
        .doc-size{font-size:13px;color:${C.muted};margin-top:2px;}
        .doc-btn{padding:8px 18px;background:${C.orange};color:#fff;border:none;border-radius:8px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:opacity .2s;flex-shrink:0;text-decoration:none;}
        .doc-btn:hover{opacity:.85;}
        .no-doc{font-size:15px;color:${C.muted};padding:16px 18px;font-style:italic;}
        .links-list{display:flex;flex-direction:column;}
        .link-item{display:flex;align-items:center;gap:13px;padding:14px 18px;text-decoration:none;color:${C.ink2};font-size:15px;font-weight:700;transition:background .18s;border-bottom:1px solid ${C.cardBd};}
        .link-item:last-child{border-bottom:none;}
        .link-item:hover{background:${C.oLight};color:${C.orange};}
        .note-item{margin:10px 18px;background:${isDark?'rgba(255,255,255,.04)':'#fff'};border:1px solid ${C.cardBd};border-radius:10px;padding:14px;}
        .ni-head{display:flex;justify-content:space-between;margin-bottom:6px;}
        .ni-auth{font-size:13px;font-weight:700;color:${C.orange};}
        .ni-date{font-size:12px;color:${C.muted};}
        .ni-text{font-size:15px;color:${C.ink2};line-height:1.65;}
        .note-ta{display:block;width:calc(100% - 36px);margin:12px 18px 10px;padding:13px 15px;border:1.5px solid ${C.inputBd};border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;color:${C.inputT};resize:vertical;outline:none;background:${C.input};transition:border-color .2s;}
        .note-ta:focus{border-color:${C.orange};}
        .btn-note{display:flex;align-items:center;gap:8px;margin:0 18px 16px;padding:10px 20px;background:${C.ink};color:${isDark?'#090c16':'#fff'};border:none;border-radius:9px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:opacity .2s;}
        .btn-note:hover{opacity:.85;}
        .checklist{padding:14px 18px;display:flex;flex-direction:column;gap:10px;}
        .cli{display:flex;align-items:center;gap:13px;padding:12px 16px;border-radius:10px;font-size:15px;font-weight:700;}
        .cli-ok{background:${C.gLight};color:${C.green};}
        .cli-todo{background:${C.surface};color:${C.muted};border:1px dashed ${C.cardBd};}
        .cli-dot{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;flex-shrink:0;}
        .cli-ok .cli-dot{background:rgba(25,135,84,.15);}
        .cli-todo .cli-dot{background:rgba(107,127,146,.1);}
        .status-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:16px 18px;}
        .stt-btn{display:flex;flex-direction:column;gap:5px;padding:15px 16px;border-radius:11px;font-family:'Plus Jakarta Sans',sans-serif;cursor:pointer;transition:all .2s;border:1.5px solid var(--bd);background:var(--bg);color:var(--c);text-align:left;}
        .stt-btn:hover,.stt-on{background:var(--c)!important;color:#fff!important;border-color:var(--c)!important;box-shadow:0 4px 16px rgba(0,0,0,.1);}
        .stt-top{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:700;}
        .stt-desc{font-size:13px;padding-left:24px;opacity:.75;}
        .stt-cur{font-size:11px;background:rgba(255,255,255,.3);border-radius:4px;padding:2px 7px;margin-left:auto;}
        .danger-block{background:${C.rLight};border:1px solid ${C.rBorder};border-radius:14px;padding:20px;}
        .db-hd{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:900;color:${C.red};margin-bottom:8px;}
        .db-p{font-size:15px;color:${C.muted};margin-bottom:14px;}
        .btn-delete{display:flex;align-items:center;gap:9px;padding:12px 22px;background:${isDark?'rgba(255,255,255,.05)':'#fff'};color:${C.red};border:1.5px solid ${C.red};border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:15px;font-weight:700;cursor:pointer;transition:all .2s;}
        .btn-delete:hover{background:${C.red};color:#fff;}
        .dest-bar{display:flex;align-items:center;gap:14px;padding:16px 18px;background:${C.oLight};border:1px solid ${C.oBorder};border-radius:12px;margin-bottom:18px;}
        .dest-label{font-size:11px;font-weight:900;color:${C.orange};text-transform:uppercase;letter-spacing:.5px;}
        .dest-email{font-size:16px;font-weight:700;color:${C.ink2};}
        .tpl-row{display:flex;align-items:center;gap:10px;margin-bottom:16px;flex-wrap:wrap;}
        .tpl-label{font-size:13px;font-weight:700;color:${C.muted};white-space:nowrap;}
        .tpl-btn{padding:9px 16px;background:${C.input};border:1.5px solid ${C.inputBd};border-radius:9px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:700;color:${C.ink2};cursor:pointer;transition:all .2s;}
        .tpl-btn:hover{border-color:${C.orange};color:${C.orange};}
        .compose-box{background:${C.surface};border:1.5px solid ${C.inputBd};border-radius:12px;overflow:hidden;margin-bottom:14px;}
        .compose-top{padding:13px 17px;border-bottom:1px solid ${C.cardBd};font-size:15px;color:${C.muted};font-style:italic;background:${C.input};}
        .compose-ta{width:100%;padding:16px 17px;border:none;outline:none;font-family:'Plus Jakarta Sans',sans-serif;font-size:16px;color:${C.inputT};resize:vertical;background:${C.input};display:block;line-height:1.75;}
        .compose-bot{padding:12px 17px;border-top:1px solid ${C.cardBd};font-size:13px;color:${C.muted};background:${C.input};}
        .compose-actions{display:flex;gap:12px;margin-bottom:24px;flex-wrap:wrap;}
        .btn-send{display:flex;align-items:center;gap:9px;padding:13px 28px;background:${C.orange};color:#fff;border:none;border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:16px;font-weight:700;cursor:pointer;transition:all .2s;box-shadow:0 4px 14px ${C.oBorder};}
        .btn-send:hover:not(:disabled){background:#e8700a;transform:translateY(-1px);}
        .btn-send:disabled{opacity:.5;cursor:not-allowed;transform:none;}
        .btn-clear{padding:13px 22px;background:${C.input};color:${C.muted};border:1.5px solid ${C.inputBd};border-radius:10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:16px;font-weight:700;cursor:pointer;transition:all .2s;}
        .btn-clear:hover{border-color:${C.ink2};color:${C.ink2};}
        .prev-section{margin-top:6px;}
        .prev-title{font-size:14px;font-weight:700;color:${C.muted};margin-bottom:12px;text-transform:uppercase;letter-spacing:.5px;}
        .prev-item{background:${C.gLight};border:1px solid ${C.gBorder};border-radius:10px;padding:14px 16px;margin-bottom:10px;border-left:4px solid ${C.green};}
        .prev-head{display:flex;justify-content:space-between;margin-bottom:6px;font-size:13px;}
        .prev-head span:first-child{font-weight:700;color:${C.green};}
        .prev-head span:last-child{color:${C.muted};}
        .prev-item p{font-size:15px;color:${C.ink2};line-height:1.7;white-space:pre-wrap;}
        .timeline{padding:16px 18px;display:flex;flex-direction:column;}
        .tl-row{display:flex;gap:16px;position:relative;padding-bottom:20px;}
        .tl-row:last-child{padding-bottom:0;}
        .tl-dot{width:34px;height:34px;border-radius:50%;background:${C.white};border:2px solid;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:10px;}
        .tl-line{position:absolute;left:16px;top:36px;bottom:0;width:2px;background:${C.cardBd};}
        .tl-body{display:flex;flex-direction:column;gap:3px;padding-top:6px;}
        .tl-act{font-size:16px;font-weight:700;color:${C.ink};}
        .tl-dt{font-size:13px;color:${C.muted};}
        @keyframes spin{to{transform:rotate(360deg)}}
        @media(max-width:1280px){.kpis{grid-template-columns:repeat(3,1fr);}}
        @media(max-width:768px){.pb{padding:16px;}.top-bar{flex-direction:column;align-items:flex-start;gap:14px;}.kpis{grid-template-columns:1fr 1fr;}.filters{flex-direction:column;align-items:stretch;}.mbox{max-width:100%;border-radius:20px 20px 0 0;align-self:flex-end;max-height:96vh;}.status-grid{grid-template-columns:1fr;}}
      `}</style>

      {toast && <Toast msg={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
      <Navbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} pageTitle="Partenariats" adminName="Jean Dupont"/>

      <main className="pw-main" style={{ marginLeft:mainML, paddingTop:mainPT }}>
        <div className="pb">

          {/* En-tête */}
          <div className="top-bar">
            <div className="top-left">
              <div className="top-icon"><FaHandshake/></div>
              <div>
                <h1 className="top-title">Demandes de Partenariat</h1>
                <p className="top-sub">Gestion et traitement des candidatures consultants et entreprises</p>
              </div>
            </div>
            <button className="btn-export" onClick={exportCSV}><FaDownload/> Exporter CSV</button>
          </div>

          {/* KPIs */}
          <div className="kpis">
            {[
              {n:stats.total,      l:'Total dossiers', c:C.ink,   bar:C.surface},
              {n:stats.nouveau,    l:'Nouveaux',        c:C.slate, bar:C.sLight},
              {n:stats.en_analyse, l:'En analyse',      c:C.amber, bar:C.aLight},
              {n:stats.approuve,   l:'Approuvés',       c:C.green, bar:C.gLight},
              {n:stats.rejete,     l:'Rejetés',         c:C.red,   bar:C.rLight},
            ].map((k,i) => (
              <div key={i} className="kpi-card">
                <span className="kpi-num" style={{color:k.c}}>{k.n}</span>
                <span className="kpi-lbl">{k.l}</span>
                <div className="kpi-bar" style={{background:k.bar}}/>
              </div>
            ))}
          </div>

          {/* Filtres */}
          <div className="filters">
            <div className="search-box">
              <FaSearch/>
              <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Nom, email ou référence…"/>
            </div>
            <div className="toggle-type">
              {[{v:'all',l:'Tous'},{v:'consultant',l:'Consultants'},{v:'entreprise',l:'Entreprises'}].map(o=>(
                <button key={o.v} className={`tgl ${fType===o.v?'tgl-on':''}`} onClick={()=>{setFType(o.v);setPage(1);}}>{o.l}</button>
              ))}
            </div>
            <select className="sel-status" value={fStatus} onChange={e=>{setFStatus(e.target.value);setPage(1);}}>
              <option value="all">Tous les statuts</option>
              <option value="nouveau">Nouveau</option>
              <option value="en_analyse">En analyse</option>
              <option value="en_attente">En attente</option>
              <option value="approuve">Approuvé</option>
              <option value="rejete">Rejeté</option>
            </select>
            <span className="result-label">{meta.total} dossier{meta.total>1?'s':''}</span>
          </div>

          {/* Tableau */}
          <div className="table-card">
            {loading ? (
              <div style={{textAlign:'center',padding:'60px 20px',color:C.muted}}>
                <FaSpinner style={{fontSize:32,display:'block',margin:'0 auto 12px',animation:'spin 1s linear infinite'}}/>
                <p style={{fontSize:14,fontWeight:700}}>Chargement…</p>
              </div>
            ) : (
              <div className="table-scroll">
                <table className="tbl">
                  <thead>
                    <tr>
                      <th>Candidat / Organisation</th>
                      <th>Profil</th>
                      <th>Domaine / Rôle</th>
                      <th>Localisation</th>
                      <th>Statut</th>
                      <th>Dépôt</th>
                      <th style={{textAlign:'center'}}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length===0 ? (
                      <tr><td colSpan={7} className="empty-td">
                        <FaHandshake style={{fontSize:44,opacity:.15,display:'block',margin:'0 auto 12px'}}/>
                        Aucun dossier ne correspond à votre recherche
                      </td></tr>
                    ) : data.map(d => {
                      const st  = statusCfg(d.status);
                      const nom = displayName(d);
                      return (
                        <tr key={d.db_id} className="trow" onClick={()=>openModal(d)}>
                          <td>
                            <div className="cand-wrap">
                              <div className="cav" style={{background:d.type==='consultant'?C.oLight:C.gLight, color:d.type==='consultant'?C.orange:C.green}}>{initials(nom)}</div>
                              <div>
                                <div className="cname">{nom}</div>
                                <div className="cemail">{d.email}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className={`type-badge ${d.type==='consultant'?'tb-c':'tb-e'}`}>
                              {d.type==='consultant'?<FaUserTie/>:<FaBuilding/>}
                              {d.type==='consultant'?'Consultant':'Entreprise'}
                            </span>
                          </td>
                          <td>
                            <div className="domain-main">{domain(d)}</div>
                            {d.type==='consultant'&&<div className="domain-sub">{d.anneesExperience} ans d'expérience</div>}
                            {d.type==='entreprise'&&d.dateCreation&&<div className="domain-sub">Depuis {new Date(d.dateCreation).getFullYear()}</div>}
                          </td>
                          <td><span className="loc">{location(d)}</span></td>
                          <td>
                            <span className="status-badge" style={{color:st.color,background:st.bg,borderColor:st.border}}>
                              <FaCircle style={{fontSize:6}}/> {st.label}
                            </span>
                          </td>
                          <td><span className="date-txt">{fmtDate(d.dateDepot)}</span></td>
                          <td onClick={e=>e.stopPropagation()}>
                            <div className="row-acts">
                              <button className="ra ra-view" title="Voir" onClick={()=>openModal(d,'dossier')}><FaEye/></button>
                              <button className="ra ra-dec"  title="Décision" onClick={()=>openModal(d,'decision')}><FaCheckDouble/></button>
                              <button className="ra ra-msg"  title="Contacter" onClick={()=>openModal(d,'contact')}><FaEnvelope/></button>
                              <button className="ra ra-del"  title="Supprimer"
                                disabled={actionLoad===d.db_id+'_delete'}
                                onClick={()=>deleteItem(d.db_id)}>
                                {actionLoad===d.db_id+'_delete' ? <FaSpinner style={{animation:'spin 1s linear infinite'}}/> : <FaTrash/>}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {meta.last_page > 1 && (
              <div className="pager">
                <button className="pbt" onClick={()=>setPage(1)} disabled={page===1}>«</button>
                <button className="pbt" onClick={()=>setPage(p=>p-1)} disabled={page===1}><FaChevronLeft/></button>
                {Array.from({length:meta.last_page},(_,i)=>i+1)
                  .filter(p=>p===1||p===meta.last_page||Math.abs(p-page)<=1)
                  .reduce((acc,p,idx,arr)=>{if(idx>0&&arr[idx-1]!==p-1)acc.push('…');acc.push(p);return acc;},[])
                  .map((p,i)=>p==='…'
                    ?<span key={`e${i}`} className="pdot">…</span>
                    :<button key={p} className={`pbt ${page===p?'pbt-on':''}`} onClick={()=>setPage(p)}>{p}</button>
                  )}
                <button className="pbt" onClick={()=>setPage(p=>p+1)} disabled={page===meta.last_page}><FaChevronRight/></button>
                <button className="pbt" onClick={()=>setPage(meta.last_page)} disabled={page===meta.last_page}>»</button>
                <span className="pinfo">Page {page}/{meta.last_page} · {meta.total} dossiers</span>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* MODAL */}
      {modal && (
        <div className="overlay" onClick={closeModal}>
          <div className="mbox" onClick={e=>e.stopPropagation()}>

            {/* Header */}
            <div className="mhdr">
              {sel ? (
                <div className="mhdr-l">
                  <div className="mav" style={{background:sel.type==='consultant'?C.oLight:C.gLight, color:sel.type==='consultant'?C.orange:C.green}}>
                    {initials(displayName(sel))}
                  </div>
                  <div>
                    <div className="mhdr-meta">
                      <span className={`type-badge ${sel.type==='consultant'?'tb-c':'tb-e'}`} style={{fontSize:12}}>
                        {sel.type==='consultant'?<FaUserTie/>:<FaBuilding/>}
                        {sel.type==='consultant'?'Consultant':'Entreprise'}
                      </span>
                      <span className="mref">{sel.id}</span>
                      <span className="status-badge" style={{color:statusCfg(sel.status).color,background:statusCfg(sel.status).bg,borderColor:statusCfg(sel.status).border}}>
                        <FaCircle style={{fontSize:6}}/> {statusCfg(sel.status).label}
                      </span>
                    </div>
                    <h2 className="mname">{displayName(sel)}</h2>
                    <p className="msub">{sel.email} · {sel.telephone}</p>
                  </div>
                </div>
              ) : (
                <div style={{display:'flex',alignItems:'center',gap:12,color:C.muted}}>
                  <FaSpinner style={{animation:'spin 1s linear infinite'}}/> Chargement…
                </div>
              )}
              <button className="mcx" onClick={closeModal}><FaTimes/></button>
            </div>

            {/* Tabs */}
            <div className="mtabs">
              {[
                {id:'dossier',    icon:<FaFileAlt/>,    label:'Dossier'},
                {id:'decision',   icon:<FaCheckDouble/>, label:'Décision'},
                {id:'contact',    icon:<FaEnvelope/>,   label:'Contacter'},
                {id:'historique', icon:<FaHistory/>,    label:'Historique'},
              ].map(t=>(
                <button key={t.id} className={`mtab ${tab===t.id?'mtab-on':''}`} onClick={()=>setTab(t.id)}>
                  {t.icon} {t.label}
                </button>
              ))}
            </div>

            <div className="mscroll">
              {modalLoading ? (
                <div style={{textAlign:'center',padding:'60px 20px',color:C.muted}}>
                  <FaSpinner style={{fontSize:28,display:'block',margin:'0 auto 12px',animation:'spin 1s linear infinite'}}/>
                  <p style={{fontSize:14}}>Chargement du dossier…</p>
                </div>
              ) : sel && (
                <>
                  {/* DOSSIER */}
                  {tab==='dossier' && (
                    <div className="tpad">
                      <div className="section-block">
                        <div className="sb-title"><FaIdCard style={{color:C.orange}}/> Informations principales</div>
                        <div className="info-grid">
                          {sel.type==='consultant' ? <>
                            <div className="ig-item"><label>Nom complet</label><span>{sel.prenom} {sel.nom}</span></div>
                            <div className="ig-item"><label>Email</label><span><a href={`mailto:${sel.email}`}>{sel.email}</a></span></div>
                            <div className="ig-item"><label>Téléphone</label><span>{sel.telephone}</span></div>
                            <div className="ig-item"><label>Localisation</label><span>{sel.ville}, {sel.quartier} — {sel.pays}</span></div>
                            <div className="ig-item"><label>Domaine</label><span>{DOMAIN_LABEL[sel.domaineExercice]||sel.domaineExercice}{sel.autreDomaine?` (${sel.autreDomaine})`:''}</span></div>
                            <div className="ig-item"><label>Expérience</label><span>{sel.anneesExperience} ans</span></div>
                          </>:<>
                            <div className="ig-item"><label>Entreprise</label><span>{sel.nomEntreprise}</span></div>
                            <div className="ig-item"><label>Représentant</label><span>{sel.nomRepresentant}</span></div>
                            <div className="ig-item"><label>Email</label><span><a href={`mailto:${sel.email}`}>{sel.email}</a></span></div>
                            <div className="ig-item"><label>Téléphone</label><span>{sel.telephone}</span></div>
                            <div className="ig-item"><label>Siège social</label><span>{sel.villeEntreprise}, {sel.paysEntreprise}</span></div>
                            <div className="ig-item"><label>Création</label><span>{fmtDate(sel.dateCreation)}</span></div>
                          </>}
                        </div>
                      </div>

                      {sel.type==='entreprise' && sel.motivation && (
                        <div className="section-block">
                          <div className="sb-title"><FaBriefcase style={{color:C.orange}}/> Motivation</div>
                          <blockquote className="motiv">« {sel.motivation} »</blockquote>
                        </div>
                      )}

                      <div className="two-cols">
                        <div className="section-block" style={{marginBottom:0}}>
                          <div className="sb-title"><FaFilePdf style={{color:C.orange}}/> Document joint</div>
                          {(() => {
                            const doc = sel.cv || sel.preuveExistence;
                            if (!doc) return <p className="no-doc">Aucun document joint</p>;
                            
                            // Gérer à la fois les chaînes URL et les objets
                            const isString = typeof doc === 'string';
                            let docUrl = isString ? doc : (doc.url || doc.path || doc);
                            
                            // Si l'URL est relative, ajouter le BASE_URL
                            if (docUrl && !docUrl.startsWith('http://') && !docUrl.startsWith('https://')) {
                              docUrl = `${BASE_URL}${docUrl.startsWith('/') ? '' : '/'}${docUrl}`;
                            }
                            
                            const docName = isString 
                              ? (docUrl?.split('/').pop()?.split('?')[0]?.replace(/^[^-]+-/, '') || 'Document.pdf')
                              : (doc.name || doc.original_name || 'Document.pdf');
                            const docSize = (!isString && doc.size) 
                              ? `${(doc.size / 1024).toFixed(0)} Ko` 
                              : '';
                            
                            return (
                              <div className="doc-card">
                                <FaFilePdf style={{color:C.red,fontSize:26,flexShrink:0}}/>
                                <div className="doc-info">
                                  <div className="doc-name">{docName}</div>
                                  {docSize && <div className="doc-size">{docSize}</div>}
                                </div>
                                <a className="doc-btn" href={docUrl} target="_blank" rel="noopener noreferrer">Consulter</a>
                              </div>
                            );
                          })()}
                        </div>
                        <div className="section-block" style={{marginBottom:0}}>
                          <div className="sb-title"><FaGlobe style={{color:C.orange}}/> Présence en ligne</div>
                          <div className="links-list">
                            {(sel.linkedinConsultant||sel.linkedinEntreprise) && (
                              <a className="link-item" href={sel.linkedinConsultant||sel.linkedinEntreprise} target="_blank" rel="noopener noreferrer">
                                <FaLinkedin style={{color:'#0A66C2',fontSize:18,flexShrink:0}}/><span>Profil LinkedIn</span>
                                <FaArrowRight style={{marginLeft:'auto',fontSize:12,color:C.muted}}/>
                              </a>
                            )}
                            {sel.siteWeb && (
                              <a className="link-item" href={sel.siteWeb} target="_blank" rel="noopener noreferrer">
                                <FaGlobe style={{color:C.green,fontSize:18,flexShrink:0}}/><span>Site web</span>
                                <FaArrowRight style={{marginLeft:'auto',fontSize:12,color:C.muted}}/>
                              </a>
                            )}
                            {!sel.linkedinConsultant&&!sel.linkedinEntreprise&&!sel.siteWeb&&<p className="no-doc">Aucun lien renseigné</p>}
                          </div>
                        </div>
                      </div>

                      <div className="section-block" style={{marginTop:18}}>
                        <div className="sb-title"><FaStickyNote style={{color:C.orange}}/> Notes internes</div>
                        {(!sel.notes||sel.notes.length===0)&&<p className="no-doc">Aucune note pour ce dossier.</p>}
                        {(sel.notes||[]).map((n,i)=>(
                          <div key={i} className="note-item">
                            <div className="ni-head"><span className="ni-auth">{n.auteur}</span><span className="ni-date">{n.date}</span></div>
                            <p className="ni-text">{n.texte}</p>
                          </div>
                        ))}
                        <textarea className="note-ta" rows={3} value={noteTxt} onChange={e=>setNoteTxt(e.target.value)} placeholder="Ajouter une note interne…"/>
                        <button className="btn-note" disabled={actionLoad===sel.db_id+'_note'}
                          onClick={()=>addNote(sel.db_id)}>
                          {actionLoad===sel.db_id+'_note' ? <FaSpinner style={{animation:'spin 1s linear infinite'}}/> : <FaPlus/>}
                          Enregistrer la note
                        </button>
                      </div>
                    </div>
                  )}

                  {/* DÉCISION */}
                  {tab==='decision' && (
                    <div className="tpad">
                      <div className="section-block">
                        <div className="sb-title"><FaCheckDouble style={{color:C.orange}}/> Checklist avant décision</div>
                        <div className="checklist">
                          {[
                            {l:'Dossier reçu et référencé',  ok:true},
                            {l:'Dossier analysé',             ok:sel.status!=='nouveau'&&sel.status!=='submitted'&&sel.status!=='draft'},
                            {l:'Notes internes rédigées',     ok:(sel.notes||[]).length>0},
                            {l:'Documents vérifiés',          ok:!!(sel.cv||sel.preuveExistence)},
                            {l:'Décision finale prise',       ok:['approuve','rejete','accepted','rejected'].includes(sel.status)},
                            {l:'Candidat informé par email',  ok:(sel.reponses||[]).length>0},
                          ].map((it,i)=>(
                            <div key={i} className={`cli ${it.ok?'cli-ok':'cli-todo'}`}>
                              <div className="cli-dot">{it.ok?<FaCheck/>:<FaRegClock/>}</div>
                              <span>{it.l}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="section-block">
                        <div className="sb-title"><FaEdit style={{color:C.orange}}/> Changer le statut du dossier</div>
                        <div className="status-grid">
                          {[
                            {k:'nouveau',    icon:<FaCircle/>,     label:'Nouveau',        desc:"Remettre en file d'attente"},
                            {k:'en_analyse', icon:<FaRegClock/>,   label:'En analyse',     desc:"Démarrer l'examen du dossier"},
                            {k:'en_attente', icon:<FaFileAlt/>,    label:'Infos requises', desc:'Demander des éléments supplémentaires'},
                            {k:'approuve',   icon:<FaThumbsUp/>,   label:'Approuver',      desc:'Valider et intégrer au réseau'},
                            {k:'rejete',     icon:<FaThumbsDown/>, label:'Rejeter',        desc:'Refuser la candidature'},
                          ].map(s=>(
                            <button key={s.k}
                              className={`stt-btn ${sel.status===s.k?'stt-on':''}`}
                              style={{'--c':statusCfg(s.k).color,'--bg':statusCfg(s.k).bg,'--bd':statusCfg(s.k).border}}
                              disabled={!!actionLoad}
                              onClick={()=>changeStatus(sel.id, sel.db_id, s.k)}>
                              <div className="stt-top">{s.icon}<span>{s.label}</span>{sel.status===s.k&&<span className="stt-cur">Actuel</span>}</div>
                              <div className="stt-desc">{s.desc}</div>
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="danger-block">
                        <div className="db-hd"><FaExclamationTriangle/> Zone dangereuse</div>
                        <p className="db-p">Cette action est irréversible. Le dossier sera définitivement supprimé.</p>
                        <button className="btn-delete" onClick={()=>deleteItem(sel.db_id)}><FaTrash/> Supprimer ce dossier</button>
                      </div>
                    </div>
                  )}

                  {/* CONTACTER */}
                  {tab==='contact' && (
                    <div className="tpad">
                      <div className="dest-bar">
                        <FaEnvelope style={{color:C.orange,fontSize:18,flexShrink:0}}/>
                        <div>
                          <div className="dest-label">Destinataire</div>
                          <div className="dest-email">{sel.email}</div>
                        </div>
                      </div>
                      <div className="tpl-row">
                        <span className="tpl-label">Modèles :</span>
                        {[
                          {l:'✅ Approbation', t:`Nous avons le plaisir de vous informer que votre candidature au partenariat CINEF a été approuvée.\n\nBienvenue dans notre réseau ! Vous recevrez votre accès à l'espace partenaire sous 48h.\n\nCordialement,`},
                          {l:'⏳ En attente',  t:`Votre dossier est en cours d'examen. Nous vous recontacterons prochainement.\n\nCordialement,`},
                          {l:'❌ Refus',       t:`Après examen de votre candidature, nous ne pouvons pas y donner suite à ce stade. Nous vous encourageons à re-candidater ultérieurement.\n\nCordialement,`},
                        ].map((t,i)=><button key={i} className="tpl-btn" onClick={()=>setReplyTxt(t.t)}>{t.l}</button>)}
                      </div>
                      <div className="compose-box">
                        <div className="compose-top">Bonjour {sel.type==='consultant'?sel.prenom:sel.nomRepresentant},</div>
                        <textarea className="compose-ta" rows={8} value={replyTxt} onChange={e=>setReplyTxt(e.target.value)} placeholder="Rédigez votre message ici…"/>
                        <div className="compose-bot">Cordialement, · <strong>L'équipe CINEF Formation</strong> · info@cinef-bj.com</div>
                      </div>
                      <div className="compose-actions">
                        <button className="btn-send" disabled={!replyTxt.trim()||sending} onClick={()=>sendReply(sel.db_id)}>
                          <FaPaperPlane/>{sending?'Envoi en cours…':"Envoyer l'email"}
                        </button>
                        <button className="btn-clear" onClick={()=>setReplyTxt('')}>Effacer</button>
                      </div>
                      {(sel.reponses||[]).length>0 && (
                        <div className="prev-section">
                          <div className="prev-title">Échanges précédents ({sel.reponses.length})</div>
                          {sel.reponses.map((r,i)=>(
                            <div key={i} className="prev-item">
                              <div className="prev-head"><span>{r.auteur}</span><span>{r.date}</span></div>
                              <p>{r.texte}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* HISTORIQUE */}
                  {tab==='historique' && (
                    <div className="tpad">
                      <div className="section-block">
                        <div className="sb-title"><FaHistory style={{color:C.orange}}/> Historique des actions</div>
                        <div className="timeline">
                          {(sel.historique||[]).length===0 && <p style={{color:C.muted,padding:'16px 18px',fontSize:15,fontStyle:'italic'}}>Aucun historique disponible.</p>}
                          {(sel.historique||[]).map((h,i)=>(
                            <div key={i} className="tl-row">
                              <div className="tl-dot" style={{borderColor:(HISTO_COLOR[h.icone]||C.muted)+'50',color:HISTO_COLOR[h.icone]||C.muted}}>
                                <FaCircle style={{fontSize:7}}/>
                              </div>
                              {i<(sel.historique.length-1)&&<div className="tl-line"/>}
                              <div className="tl-body">
                                <span className="tl-act">{h.action}</span>
                                <span className="tl-dt">{h.date}{h.auteur&&h.auteur!=='Système'?' · '+h.auteur:''}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatnersAdmin;